import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  category: string,
 *  indicatorType: string,
 *  description: string,
 *  sortOrder: number,
 *  type: string,
 *  status: string }} OutputOutcome
 */

const api = new Api("api/Indicators");

/**
 * @param reportingYear
 * @returns {Promise<AxiosResponse<OutputOutcome[]>>}
 */
export const getSummaries = (reportingYear) =>
  api.get(`summaries/${reportingYear}`);

export const getIndicatorById = (id) => api.get(id);

export const getDropdownData = () => api.get("dropdownData");

export const getDropdownDataByProjectId = (projectId) =>
  api.get(`dropdownData/${projectId}`);

export const getGroupings = () => api.get("groupings");

export const updateGroupings = (payload) => api.put("groupings", payload);

export const deleteGrouping = (id) => api.del(`groupings/${id}`);

export const addIndicator = (payload) => api.post("", payload);

export const updateIndicator = (id, payload) => api.putId(id, payload);

/**
 * @param {string} cellLocator
 * @param {number=} indicatorId
 * @returns {Promise<AxiosResponse<boolean>>}
 */
export const validateCellLocator = (cellLocator, indicatorId) =>
  api.get(
    `validateCellLocator/${cellLocator}`,
    indicatorId
      ? {
          indicatorId,
        }
      : undefined
  );
